/**
 * 获取变量的类型
 * @param {*要获取类型的变量} obj
 */
export const getObjType = (obj) => {
    const type = Object.prototype.toString.call(obj)
    switch (type) {
        case '[object Array]':
            return 'Array'
            break
        case '[object Object]':
            return 'Object'
            break
        case '[object Function]':
            return 'Function'
            break
        case '[object Undefined]':
            return 'Undefined'
            break
        case '[object Null]':
            return 'Null'
            break
        case '[object Number]':
        case '[object String]':
        case '[object Boolean]':
            return 'Base'
            break
        default:
            return 'Error'
            break
    }
}

/**
 * @desc 对比两个任意类型的变量是否相等(暂不支持Function),原定要在合作伙伴那块写用，后来没用上
 * @param {*要对比的两个变量} ab
 */
export const equarComplex = (a, b) => {
    // 判断类型
    const typeA = getObjType(a)
    const typeB = getObjType(b)
    if (typeA !== typeB) {
        return false
    } else if (typeA === 'Base') {
        return a === b
    } else if (typeA === 'Array') {
        if (a.length !== b.length) {
            return false
        } else {
            // 循环遍历数组的值进行比较
            for (let i = 0; i < a.length; i++) {
                if (!equarComplex(a[i], b[i])) {
                    return false
                }
            }
            return true
        }
    } else if (typeA === 'Object') {
        if (Object.keys(a).length !== Object.keys(b).length) {
            return false
        }
        for (const o in a) {
            if (!equarComplex(a[o], b[o])) {
                return false
            }
        }
        return true
    } else if (typeA === 'Undefined' || typeA === 'Null') {
        return true
    } else {
        return false
    }
}

// 对象去空
export const delNullProperty = function (data) {
    const obj = JSON.parse(JSON.stringify(data))
    for (const i in obj) {//遍历对象中的属性
        if (obj[i] === undefined || obj[i] === null || obj[i] === "") {//首先除去常规空数据，用delete关键字
            delete obj[i]
        } else if (obj[i].constructor === Object) {//如果发现该属性的值还是一个对象，再判空后进行迭代调用
            if (Object.keys(obj[i]).length === 0) delete obj[i]//判断对象上是否存在属性，如果为空对象则删除
            obj[i] = delNullProperty(obj[i])
        } else if (obj[i].constructor === Array) {//对象值如果是数组，判断是否为空数组后进入数据遍历判空逻辑
            if (obj[i].length === 0) {//如果数组为空则删除
                delete obj[i]
            } else {
                for (let index = 0; index < obj[i].length; index++) {//遍历数组
                    if (obj[i][index] === undefined || obj[i][index] === null || obj[i][index] === "" || JSON.stringify(obj[i][index]) === "{}") {
                        obj[i].splice(index, 1)//如果数组值为以上空值则修改数组长度，移除空值下标后续值依次提前
                        index--//由于数组当前下标内容已经被替换成下一个值，所以计数器需要自减以抵消之后的自增
                    }
                    if (obj[i][index].constructor === Object) {//如果发现数组值中有对象，则再次进入迭代
                        obj[i][index] = delNullProperty(obj[i][index])
                    }
                }
            }   
        }
    }
    return obj
}